import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PlotRange } from 'components/cell-visualizations/tsv/types'

// Subset of the values for Plotly's dragmode/modebar that we want to support
// these strings are the datatitles for plotly's modebar <a> elements
// Note: 'Leiden Select' is a UI mode that maps to Plotly's 'pan' dragmode
export const modebarDragActions = ['Pan', 'Box Select', 'Lasso Select', 'Leiden Select'] as const
export type ModebarDragAction = (typeof modebarDragActions)[number]

export const modebarEventActions = [
  'Download plot as a png',
  'Autoscale',
  'Zoom out',
  'Zoom in',
] as const
export type ModebarEventAction = (typeof modebarEventActions)[number]

// Custom toolbar actions that are handled by ToolButtons directly, not by Plotly's modebar
export const customToolbarActions = ['Tune Hyperparameters'] as const
export type CustomToolbarAction = (typeof customToolbarActions)[number]

export type ModebarAction = ModebarEventAction | ModebarDragAction | CustomToolbarAction | undefined

interface PlotlyState {
  dragMode: ModebarDragAction
  singlePlotRange?: PlotRange
  multiPlotRange?: PlotRange
}

const plotlySliceInitialState: PlotlyState = {
  dragMode: 'Pan',
}

export const plotlySlice = createSlice({
  name: 'plotly',
  initialState: plotlySliceInitialState,
  reducers: {
    setSinglePlotRange: (state, action: PayloadAction<PlotRange>) => {
      state.singlePlotRange = action.payload
    },
    setMultiPlotRange: (state, action: PayloadAction<PlotRange>) => {
      state.multiPlotRange = action.payload
    },
    setDragMode: (state, action: PayloadAction<ModebarDragAction>) => {
      state.dragMode = action.payload
    },
  },
})

export const PlotlyActions = plotlySlice.actions
export const PlotlyReducer = plotlySlice.reducer
